import React, { useState, useRef, useCallback, useEffect } from 'react'
import { Row, Col, Form, Card } from '@deere/ux.uxframe-react'
import BusinessSegmentationPage from './BusinessSegmentationPage'
import LaborAbsenteeismPage from './LaborAbsenteeismPage'
import ButtonsSection from '../../components/ButtonsSection'
import FlexibilityPage from './FlexibilityPage'
import CapacityConstraints from './CapacityConstraintsPage'
import { TierPage } from './TierPage';
import LeftMenu from '../../components/LeftMenu'
import { useSelector } from 'react-redux'
import CustomAlert from '../../components/CustomAlert'
import { isSupplierAllowed,getDateFromTimeStamp } from '../../utils/utils'
import { useHistory, useLocation } from 'react-router'
import { EMPTY_BODY, TIER_LABOR_NAME_INDIRECT,DATE_FORMAT } from '../../utils/surveyLiterals'
import { showTierModal } from '../../redux/action/modalAction'
import store from '../../redux/store'
import { useDispatch } from 'react-redux'
import { getSectionsWithErrors, validationOnCheckboxes, validateTier2Inputs } from '../../utils/validation'
import { useTranslation } from "react-i18next";
import { savedSuccessFullySurvey } from '../../redux/action/saveAction'
import {handleSaveOrUpdate,deleteAnswers} from '../../utils/saveSurveyUtils'
import { useOktaAuth } from '@okta/okta-react';
import { getCountry } from '../../services/external.service';
import FutureConsideration from './FutureConsiderationPage'
import { format } from 'date-fns'



export default function ScbmIndirectSurveyPage({ survey, setSurvey, surveyLanguages }) {
    const pages = survey.sections.map(it=> it.description);
    const containsT2 = survey.sections.find(it=> it.code === 'ind_t2')?true:false;
    let sectionsTitles = [...pages]
    const { authState } = useOktaAuth();
    const surveyResponse = useSelector(state => state.survey.surveyResponse)
    const userInfo = useSelector(state => state.survey.userInfo)
    const [actLink, setActLink] = useState(new Array(sectionsTitles.length).fill(""));
    const [validated, setValidated] = useState(false)
    const [errors, setErrors] = useState([])
    const totalBs = useSelector(state => state.survey.total)
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const surveySaved = useSelector((state) => state.save.saveSurvey)
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const campaign = store.getState().campaign.campaignAssigned;
    const [country, setCountry] = useState([]);
    const [title] = useState({
        updatedByName: location && location.state ? location.state.updatedByName : campaign.updatedByName,
        supplierName: location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName,
        surveyType: location && location.state ? location.state.surveyType : survey.description,
        updatedTs: location && location.state ? location.state.updatedTs : campaign.assignments[0].updatedTs
    })

    const handleScroll = useCallback(() => {
        const currentScrollPos = window.pageYOffset;
        let tmpActLink = new Array(sectionsTitles.length).fill("");
        let tmpRefs = []
        sectionsRef.current.map((section) =>
            ((currentScrollPos + 300) >= (section.offsetTop)) ? tmpRefs.push('active') : tmpRefs.push('')
        )
        tmpActLink[tmpRefs.lastIndexOf('active')] = 'active'
        setActLink(tmpActLink)
    }, [sectionsTitles.length, location.state]);

    const surveyTitle = () => {
        if (title) {
            if (!title.updatedByName) {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName} <br/>
                        <span>Due date {getDateFromTimeStamp(new Date(campaign.endDate))}</span>
                    </h5>
                </div>)
            }
            else {
                return (<div className='p-2'>
                    <h1>{title.surveyType}</h1>
                    <h5>{title.supplierName} </h5>
                    <h5>Due date {getDateFromTimeStamp(new Date(campaign.endDate))} </h5>
                    <h5> {` Last saved on ${title.updatedTs} by ${title.updatedByName}`}</h5>
                </div>)
            }
        }
        return null
    }


    const getContries = async () => {
        let response = [];
        try {
            response = await getCountry(authState.accessToken.accessToken);
        } catch (err) {
            console.log(err);
        }
        if (response.length !== 0) {
            response.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0))
            setCountry([...response]);
        }
    };

    useEffect(() => {
        getContries();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!survey) {
        return EMPTY_BODY;
    }

    const handleSubmit = event => {
        const form = event.currentTarget;
        if(containsT2){
            validateTier2Inputs(form,TIER_LABOR_NAME_INDIRECT);
        }
        
        let errorSections = getSectionsWithErrors(form);
        
        if (totalBs !== 100) {
            const bsAlert = document.querySelectorAll('[id=bsTotal]')
            const bsSection = bsAlert && bsAlert.length > 0 ? bsAlert[0].getAttribute('name') : ''
            if(bsSection && errorSections.findIndex(err => err  === bsSection) < 0)
                errorSections.push(bsSection);            
        }
        
        const checkboxes = document.querySelectorAll('input[type=checkbox]');
        validationOnCheckboxes(checkboxes, errorSections);
        setErrors(errorSections);

        if (errors && errors.length > 0) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        setValidated(true);
        event.preventDefault();
        event.stopPropagation();
        const surveyAnswersTmp = [...store.getState().survey.surveyAnswers];
        const tierAnswers = surveyAnswersTmp.filter(answer => answer.tierIndex > 0 && answer.answer.trim() !== '')
        deleteAnswers(surveyAnswersTmp,survey);
        if (form.checkValidity() && errorSections.length <= 0) {
            setValidated(false);
            dispatch(savedSuccessFullySurvey({ variant: undefined, description: undefined }));
            
            if (tierAnswers || tierAnswers.length > 0) {
                let isEmpty = true;
                tierAnswers.forEach(ans => {
                    if (ans.answer.trim() !== '') {
                        isEmpty = false
                    }
                });
                if (containsT2 && isEmpty) {
                    dispatch(showTierModal(true));
                } else {
                    handleSaveOrUpdate(surveyResponse, surveyAnswersTmp, campaign, userInfo, authState, dispatch, t('lbl_success_save_message'));
                   
                        const updByName = location && location.state ? location.state.updatedByName : campaign.updatedByName;
                        const supplierName = location && location.state ? location.state.supplierName : campaign.assignments[0].supplierName;
                        const surveyType = location && location.state ? location.state.surveyType : survey.description;
                    
                    history.push({
                        pathname: '/review',
                        state: {
                            previous: '/scbm',
                            survey: survey,
                            updatedByName: updByName,
                            supplierName: supplierName,
                            surveyType: surveyType,
                            campaign:campaign,
                            updatedTs: location && location.state ? location.state.updatedTs : ""
                        }
                    })
                }
            }else{
                console.log("***TIER II ISSUE***")
                console.log(tierAnswers)
                console.log("*******************")
            }
        } else {
            window.scrollTo(0, 0);
        }

    }

    const showErrorCard = <>
        <Card className='p-2 mb-2 bg-danger'>
            <Card.Body className="uxf-card-body-table">
                <Card.Title className='pb-3 text-white'>
                    {t('lbl_error_survey_validation')}
                </Card.Title>
                {
                    errors.map((error, index) =>
                        <div key={index}>
                            <li className='text-white'>{error}</li>
                        </div>
                    )
                }
            </Card.Body>
        </Card>
        <br />
    </>

    function clearErrors(){
        setValidated(false);
        setErrors([]);
    }


    return (<div>
        <Row>
            {surveyTitle()}
        </Row>
        <Row>
            <Col xs={24} md={5}>
                {actLink.length > 0 && <LeftMenu actLink={actLink} survey={survey} />}
            </Col>
            <Col xs={24} md={19}>
                {
                    errors.length > 0 ? showErrorCard : null
                }
                {
                    surveySaved.variant === 'success' ?
                        <CustomAlert accessibilityLabel={surveySaved.variant} variant={surveySaved.variant} title={surveySaved.description} />
                        : null
                }                
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div ref={el => sectionsRef.current[0] = el}>
                        <BusinessSegmentationPage survey={survey} />
                    </div>
                    <br />
                    <div ref={el => sectionsRef.current[1] = el}>
                        <LaborAbsenteeismPage survey={survey} countries={country}/>
                    </div>
                    <br />
                    <div ref={el => sectionsRef.current[3] = el}>
                        <CapacityConstraints survey={survey} />
                    </div>
                    <br />
                    <div ref={el => sectionsRef.current[4] = el}>
                        <FlexibilityPage survey={survey} />
                    </div>
                    <br />
                    {
                    containsT2 && <><div ref={el => sectionsRef.current[5] = el}>
                                <TierPage survey={survey} country={country} updatedByName={!location.state ? '' : location.state.updatedByName} supplierName={!location.state ? '' : location.state.supplierName} />
                            </div>
                        <br />
                    </>
                    }
                    <div ref={el => sectionsRef.current[containsT2?6:5] = el}>
                        <FutureConsideration survey={survey} />
                    </div>
                    <br />
                    {userInfo && isSupplierAllowed(userInfo.userType) &&
                        <ButtonsSection
                            setSurvey={setSurvey}
                            campaign={campaign} 
                            clearFunction={clearErrors}
                            survey={survey}
                            surveyLanguages={surveyLanguages}
                        />
                    }
                </Form>
            </Col>
        </Row >
    </div>
    )
}